<template>
  <Settings
    v-if="settingsLoaded"
    :settings="settings"
    :active-tab="activeTab"
    @updateSettings="update" />
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Settings from './_components/Settings.vue';

export default {
  name: 'SettingsModule',
  components: {
    Settings,
  },
  async created() {
    if (this.$route.meta.isTab) {
      this.activeTab = this.$route.path || '';
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.meta.isTab && to.path) {
      this.activeTab = to.path;
    }
    next();
  },
  data() {
    return {
      activeTab: '',
    };
  },
  computed: {
    ...mapState('settings', {
      settings: state => state.settings,
    }),
    settingsLoaded() {
      return !!this.settings.site_name;
    },
  },
  methods: {
    ...mapActions('settings', [
      'updateSettings',
    ]),
    update(settings) {
      this.updateSettings(settings);
    },
  },
};
</script>
